import { render, staticRenderFns } from "./ApmsBasicPhenophaseInfo.vue?vue&type=template&id=558961e2&scoped=true&"
import script from "./ApmsBasicPhenophaseInfo.vue?vue&type=script&lang=js&"
export * from "./ApmsBasicPhenophaseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558961e2",
  null
  
)

export default component.exports